module.exports = __webpack_public_path__ + "static/media/future_1.9e6adcbf.jpg";